import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function restoreClesson(clessonId: any) {
    const { apiPostRestoreClesson } = apiConfig.getStaticUrls();

    return postFetch(`${apiPostRestoreClesson}${clessonId}/`);
}
